import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ClaveValorComponent } from '../../app/DTOs/ClaveValor.component';
import { StudentCardTypeComponent } from '../../app/DTOs/StudentCardType.component';
import { SolicitudComponent } from '../../app/DTOs/Solicitud.component';
import { GeneralUtils } from '../../../../Alsa-MA-Angular-utils/src/app/general-utils';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var portletNameCardRequestLiferay: any; // Nombre del portlet en Liferay
declare var showServiceTermsLiferay: any; // Determina si se debe mostrar las condiciones del servicio
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos
declare var GetCityCardTypes: any; // URL para obtener los tipos de tarjeta
declare var GetCityEtablissements: any; // URL para obtener los colegios
declare var GetCityEtablissementsBySchoollevel: any; // URL para obtener los colegios
declare var GetCityCommunesByProvince: any; // URL para obtener los colegios
declare var GetCitySchoollevels: any; // URL para obtener los niveles educativos
declare var GetLinesFromCity: string;
declare var GetCityProvinces: string;
declare var GetCityCommunes: string;
declare var GetCityZonas: string;
declare var liferayUserNoAdmin: any;

declare var i18nVS: any;
declare var showProvince: any;
declare var showCommune: any;
declare var showZone: any;
declare var showEtablissement: any;
declare var showSchoollevel: any;
declare var userLoggedEmail: any;

// Recupera la tarjeta de un estudiante
declare var SearchSolicitudes: any;

// El maximo de años permitidos para solicitar esta tarjeta
declare var maximumAgeForCardRequest: any;
declare var showMassarField: any;
declare var mandatoryMassarFieldByCardSelectedId: any;

declare var jsonCardRequestLiferay: any;

@Component({
    selector: 'app-request-form',
    templateUrl: './requestForm.component.html',
    styleUrls: ['../solicitud-tarjeta.component.css']
})

export class RequestFormComponent implements OnInit {
    SELECT_LOADING_VALUE = "-2";
    SELECT_NONE_VALUE = "-1";
    SELECT_FIRST_VALUE = "0";
    ID_CITY_AGADIR = '2';

    i18nL = i18nVS;
    portletName = ''; // Nombre del portlet
    cityId = '2';
    cardRequest = null;
    user = null;

    @Output() onWebServiceError: EventEmitter<string> = new EventEmitter<string>();
    @Output() onGeneralError: EventEmitter<string> = new EventEmitter<string>();
    @Output() onFullyLoaded: EventEmitter<boolean> = new EventEmitter<boolean>(); // True si se ha de mostrar el selector de citas

    jsonData;

    jsonCardTypes;
    cardTypes: Array<StudentCardTypeComponent> = new Array<StudentCardTypeComponent>();

    cardTypeSelected: StudentCardTypeComponent = new StudentCardTypeComponent("", "", idCiudadLiferay, true, 0, 0);
    //schoollevelSelected: SchoollevelComponent = new SchoollevelComponent("", "", idCiudadLiferay);
    schoollevelSelected = null;
    provinceSelected = null;
    communeSelected = null;
    zoneSelected = null;
    totalLineasActual = []; // Ej: [0, 1]

    jsonEtablissements;
    etablissements = [];

    jsonSchoollevels;
    schoollevels = [];

    // Validaciones
    fechaClass = '';
    emailClass = '';
    lineClass = "col-md-6";

    jsonLineas;
    lineas: Array<ClaveValorComponent> = new Array<ClaveValorComponent>();
    line1Class = '';
    line2Class = '';

    jsonProvinces;
    provinces = [];

    jsonCommunes;
    communes = [];

    jsonZones;
    zones = [];

    showProvince = idCiudadLiferay == this.ID_CITY_AGADIR;
    showCommune = showCommune;
    showZone = showZone;
    showEtablissement = showEtablissement;
    showSchoollevel = idCiudadLiferay == this.ID_CITY_AGADIR;


    // Para saber cuando estan todos los datos listos
    provincesCargadas = false;
    communesCargados = false;
    lineasCargadas = false;
    zonesCargadas = false;
    cardTypesCargadas = false;
    etablissementsCargadas = false;
    schoollevelsCargadas = false;


    // Cuando todo este cargado nos mostrara el formulario
    showForm = false;
    // Indica si estamos en modo creacion tarjeta o edicion. true es creacion y false es edicion
    isNewCardForm = true;

    // Variables para setear en el formulario de un usuario logueado
    email = userLoggedEmail;

    //bloquea el formulario para evitar que se manipulen los datos del dossier una vez a sido enviado
    blockField = false;

    // Controlamos las fechas minimas y maximas de la fecha de nacimiento
    maxDate = new Date();
    minDate = new Date();

    // Inputs
    inputName: HTMLInputElement;
    inputSurname: HTMLInputElement;
    inputCin: HTMLInputElement;
    inputBirthdate: HTMLInputElement;
    inputAddress: HTMLInputElement;
    inputPhone: HTMLInputElement;
    inputEmail: HTMLInputElement;
    inputDossierNumber: HTMLInputElement;
    inputEtablissement: HTMLInputElement;
    inputSchoollevel: HTMLSelectElement;
    inputProvince: HTMLSelectElement;
    inputCommune: HTMLSelectElement;
    inputZone: HTMLSelectElement;
    inputTypeCarteId: HTMLSelectElement;
    inputMassarField: HTMLInputElement;

    inputErrorClass = "inputError";

    solicitud: SolicitudComponent = new SolicitudComponent();
    showMassarField = this.cityId == this.ID_CITY_AGADIR ? false : showMassarField;
    mandatoryMassarFieldByCardSelectedId = mandatoryMassarFieldByCardSelectedId;
    mandatoryMassarField = false;

    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    /**
     * Inicializa los selects del formulario
     */
    private initSelects() {
        var finalUrl = GetCityCardTypes;
        this.http.post(finalUrl, new Map<string, string>()).subscribe(
            res => { this.validateJSON(res, finalUrl) },
            (err) => this.errorEnElJson(err, finalUrl),
            () => this.initCardTypes(this.jsonData)
        );



        // Si la Province se ve, se pone en modo cargando, si no se le asigna null
        if (showProvince) {
            this.provinces[0] = new ClaveValorComponent(this.SELECT_LOADING_VALUE, this.i18nL.general_cargando);
            this.getProvinces();
        } else {
            this.provinces[0] = new ClaveValorComponent(this.SELECT_NONE_VALUE, "null");
            this.provincesCargadas = true;
        }

        // Si el commune se ve, se pone en modo cargando, si no se le asigna null
        if (showCommune) {
            this.communes[0] = new ClaveValorComponent(this.SELECT_LOADING_VALUE, this.i18nL.general_cargando);
            this.getCommunes();
        } else {
            this.communes[0] = new ClaveValorComponent(this.SELECT_NONE_VALUE, "null");
            this.communesCargados = true;
        }


        // Si el zone se ve se pone en modo cargando, si no se le asigna null
        if (showZone) {
            this.zones[0] = new ClaveValorComponent(this.SELECT_LOADING_VALUE, this.i18nL.general_cargando);
            this.getZones();
        } else {
            this.zones[0] = new ClaveValorComponent(this.SELECT_NONE_VALUE, "null");
            this.zonesCargadas = true;
        }

        // Si se ven las escuelas se cargan, si no se le asigna null
        if (showEtablissement) {
            this.http.post(GetCityEtablissements, new Map<string, string>()).subscribe(
                res => { this.validateJSON(res, GetCityEtablissements) },
                (err) => this.errorEnElJson(err, GetCityEtablissements),
                () => this.initEtablissements(this.jsonData, false)
            );
        } else {
            this.etablissements[0] = new ClaveValorComponent(this.SELECT_NONE_VALUE, "null");
            this.etablissementsCargadas = true;
        }

        //Si se ven los niveles  se cargan si no se les asignas todos  
        if (showSchoollevel) {
            this.http.post(GetCitySchoollevels, new Map<string, string>()).subscribe(
                res => { this.validateJSON(res, GetCitySchoollevels) },
                (err) => this.errorEnElJson(err, GetCitySchoollevels),
                () => this.initSchoollevels(this.jsonData)
            );
        } else {
            this.schoollevels[0] = new ClaveValorComponent(this.SELECT_FIRST_VALUE, "todos");
            this.schoollevelsCargadas = true;
        }


        this.getLines();
    }

    /**
     * Procesa errores detectados en el formato JSON
     */
    private errorEnElJson(err: string, url: string) {
        console.log('Error en la llamada: ' + err);
        console.log(url);
        this.onWebServiceError.emit(err);
    }

    /**
     * valida objetos JSON
     * @param res recurso a validar
     */
    private validateJSON(res: Response, url: string) {
        try {
            this.jsonData = res.json();
        } catch (error) {
            console.log(res);
            this.errorEnElJson("Error parseando el json", url);
        }
    }

    /**
     * Inicializa los tipos de tarjeta
     */
    private initCardTypes(respuestaJSON) {
        var contador = 1;
        this.jsonCardTypes = respuestaJSON;
        this.cardTypes[0] = new StudentCardTypeComponent(this.SELECT_NONE_VALUE, "", 0, false, 0, 0);
        for (var i = 0; i < this.jsonCardTypes.length; i++) {
            if (this.jsonCardTypes[i].active == true) {
                this.cardTypes[contador] = new StudentCardTypeComponent(
                    this.jsonCardTypes[i].id,
                    this.jsonCardTypes[i].description,
                    this.jsonCardTypes[i].villeId,
                    this.jsonCardTypes[i].active,
                    this.jsonCardTypes[i].totalLines,
                    this.jsonCardTypes[i].mandatoryLines
                );
                contador++;
            }
        }

        this.cardTypesCargadas = true;
        this.getStudentRequest();
    }

    private initSchoollevels(respuestaJSON) {
        this.jsonSchoollevels = respuestaJSON;
        for (var i = 0; i < this.jsonSchoollevels.length; i++) {
            this.schoollevels.push(this.jsonSchoollevels[i]);
        }
        this.schoollevelsCargadas = true;
        this.getStudentRequest();
    }

    /**
     * Inicializa los colegios
     */
    private initEtablissements(respuestaJSON, isChange) {
        this.jsonEtablissements = respuestaJSON;
        this.etablissements = [];
        this.etablissementsCargadas = false;
        for (var i = 0; i < this.jsonEtablissements.length; i++) {
            if (this.jsonEtablissements[i].active == true) {
                this.etablissements.push(this.jsonEtablissements[i]);
            }
        }
        this.etablissementsCargadas = true;
        if (!isChange) {
            this.getStudentRequest();
        }
    }

    private validateEmailPattern(email) {
        var email_pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return email_pattern.test(email);
    }

    public initialize() {
        this.portletName = portletNameCardRequestLiferay;
        this.cityId = idCiudadLiferay;
        showSchoollevel = this.cityId !== this.ID_CITY_AGADIR ? false : true;
        showProvince = this.cityId !== this.ID_CITY_AGADIR ? false : true;
        this.etablissements = [];
        this.schoollevels = [];
    }

    public validateCardRequestForm() {
        // Limpiamos los mensajes de error
        if (this.cityId == this.ID_CITY_AGADIR && !this.isNewCardForm) {
            this.zoneChange(this.cardRequest.zone);
        }
        this.onGeneralError.emit("");
        var valid = true;

        if (!this.isMandatory(this.inputName)) {
            valid = false;
        }

        if (!this.isMandatory(this.inputSurname)) {
            valid = false;
        }

        if (!this.isMandatory(this.inputCin)) {
            valid = false;
        }

        if (!this.isMandatory(this.inputTypeCarteId)) {
            valid = false;
        }

        if (!this.isMandatory(this.inputAddress)) {
            valid = false;
        }

        if (!this.isMandatory(this.inputPhone)) {
            valid = false;
        }

        if (showEtablissement && !this.isMandatory(this.inputEtablissement)) {
            valid = false;
        }

        if (showSchoollevel && !this.isMandatory(this.inputSchoollevel)) {
            valid = false;
        }

        if (showProvince && !this.isMandatory(this.inputProvince)) {
            this.onGeneralError.emit(this.i18nL.zz04_select_valid_province);
            valid = false;
        }

        if (showCommune && !this.isMandatory(this.inputCommune)) {
            this.onGeneralError.emit(this.i18nL.zz04_select_valid_commune);
            valid = false;
        }

        if (showZone && !this.isMandatory(this.inputZone)) {
            this.onGeneralError.emit(this.i18nL.zz04_select_valid_zone);
            valid = false;
        }

        if (!this.isMandatory(this.inputBirthdate) || !this.validateMinimumAge(this.inputBirthdate.value)) {
            this.inputBirthdate.placeholder = this.i18nL.form_campoObligatorio;
            this.fechaClass = 'inputError';
            valid = false;
        }

        if (!this.isMandatory(this.inputEmail) || !this.validateEmailPattern(this.inputEmail.value.trim())) {
            this.inputEmail.placeholder = this.i18nL.form_campoObligatorio;
            this.emailClass = 'inputError';
            if (!this.validateEmailPattern(this.inputEmail.value.trim())) {
                this.onGeneralError.emit(this.i18nL.zz03_form_error_email_format);
                this.inputEmail.value = '';
                this.inputEmail.placeholder = this.i18nL.zz03_form_error_email_format;
            }
            valid = false;
        }

        // Miramos que las lineas que son obligatorias se han seleccionado, estas operaciones solo se pueden hacer si ya
        // se ha escogido un tipo de tarjeta
        if (this.inputTypeCarteId != undefined && this.inputTypeCarteId.value != this.SELECT_LOADING_VALUE &&
            this.inputTypeCarteId.value != this.SELECT_NONE_VALUE) {
            for (var i = 0; i < this.cardTypeSelected.getMandatoryLines(); i++) {
                var selectedLine = (<HTMLInputElement>document.getElementById(this.portletName + 'idLine' + i));
                if (!this.isMandatory(selectedLine)) {
                    valid = false;
                }
            }
            // Miramos tambien que ninguna linea es igual a la anterior
            var selectedLinesValues = [];
            for (var t = 0; t < this.cardTypeSelected.getTotalLines(); t++) {
                selectedLinesValues[t] = (<HTMLInputElement>document.getElementById(this.portletName + 'idLine' + t)).value.trim();
            }
            for (var z = 0; z < selectedLinesValues.length - 1; z++) {
                for (var y = z + 1; y < selectedLinesValues.length; y++) {
                    if (selectedLinesValues[z] != this.SELECT_NONE_VALUE && selectedLinesValues[z] == selectedLinesValues[y]) {
                        if (selectedLinesValues[z] != "") {
                            this.onGeneralError.emit(this.i18nL.zz04_select_diferent_lines);
                            valid = false;
                            break;
                        }
                    }
                }
            }
        } else {
            valid = false;
        }
        var typeCarteId = (<HTMLInputElement>document.getElementById(this.portletName + 'typeCarteId')).value;
        if (this.cityId == this.ID_CITY_AGADIR) {
            this.mandatoryMassarField = false;
            this.showMassarField = false
        } else {
            if (mandatoryMassarFieldByCardSelectedId.includes(typeCarteId)) {
                this.mandatoryMassarField = true;
            } else {
                this.mandatoryMassarField = false;
            }
        }
        if (this.mandatoryMassarField && !this.isMandatory(this.inputMassarField)) {
            valid = false;
        }
        return valid;
    }

    // Retorna true si es correcto y false si esta mal
    public isMandatory(input) {
        var valorActualDelInput = input.value.trim();
        if (valorActualDelInput !== '' && valorActualDelInput != this.SELECT_NONE_VALUE
            && valorActualDelInput != this.SELECT_LOADING_VALUE) {
            input.classList.remove(this.inputErrorClass)
            return true;
        } else {
            input.classList.add(this.inputErrorClass);
            if (typeof input.placeholder != 'undefined') {
                input.placeholder = this.i18nL.form_campoObligatorio;
            }
            this.onGeneralError.emit(this.i18nL.zz04_dossier_estudiantes_explicacion_2);
            return false;
        }
    }

    // Cuando el tipo de tarjeta cambia pueden tambien cambiar el numero de lineas ofrecidas
    public cardTypeChange(cardTypeSelected) {
        this.cardTypeSelected = null;
        if (cardTypeSelected != null && typeof cardTypeSelected != "undefined") {

            for (var i = 0; i < this.cardTypes.length; i++) {
                if (this.cardTypes[i].getId() == cardTypeSelected) {
                    this.cardTypeSelected = this.cardTypes[i];
                    break;
                }
            }
            this.totalLineasActual = [];
            for (var t = 0; t < this.cardTypeSelected.getTotalLines(); t++) {
                this.totalLineasActual[t] = t;
            }

            this.lineClass = "col-md-" + (12 / this.cardTypeSelected.getTotalLines());

            if (mandatoryMassarFieldByCardSelectedId.includes(this.cardTypeSelected.getId())) {
                this.mandatoryMassarField = true;
            } else {
                this.mandatoryMassarField = false;
            }
        }
    }

    public schoollevelChange(schoollevelSelected) {
        this.schoollevelSelected = null;
        this.schoollevelSelected = schoollevelSelected
        this.inputSchoollevel = <HTMLSelectElement>document.getElementById(this.portletName + 'schoollevel');
        this.inputEtablissement.removeAttribute('disabled');
        document.getElementById(this.portletName + 'etablissement').removeAttribute('disabled');
        var url = schoollevelSelected !== '0' ? GetCityEtablissementsBySchoollevel + "&" + this.portletName + "schoollevel=" + schoollevelSelected : GetCityEtablissements;
        this.http.post(url, new Map<string, string>()).subscribe(
            res => { this.validateJSON(res, url) },
            (err) => this.errorEnElJson(err, url),
            () => this.initEtablissements(this.jsonData, true)
        );
    }

    public provinceChange(provinceSelected) {
        if (this.cityId == '2') {
            document.getElementById(this.portletName + 'commune').removeAttribute('disabled');
            this.provinceSelected = null;
            this.provinceSelected = provinceSelected;
            this.inputProvince = <HTMLSelectElement>document.getElementById(this.portletName + 'province');
            for (var i = 0; i < this.jsonProvinces.length; i++) {
                if (this.jsonProvinces[i].id == provinceSelected) {
                    var url = GetCityCommunesByProvince + "&" + this.portletName + "province=" + this.jsonProvinces[i].id;
                    this.http.post(url, new Map<string, string>()).subscribe(
                        res => { this.validateJSON(res, url) },
                        (err) => this.errorEnElJson(err, url),
                        () => this.cargarCommunes(this.jsonData, true)
                    );
                }
            }
        }
    }

    public communeChange(communeSelected) {
        if (this.cityId == '2') {
            this.communeSelected = null;
            this.inputCommune = <HTMLSelectElement>document.getElementById(this.portletName + 'commune');
            for (var i = 0; i < this.jsonCommunes.length; i++) {
                if (this.jsonCommunes[i].id == communeSelected && this.inputZone != null) {
                    this.inputZone.value = this.jsonCommunes[i].zoneId;
                    document.getElementById(this.portletName + 'zone').setAttribute('value', this.jsonCommunes[i].zoneId);
                    this.zoneChange(this.jsonCommunes[i].zoneId);
                }
            }
        }
    }

    public zoneChange(zoneSelected) {
        if (this.cityId == '2') {
            var valueTranslator = zoneSelected == '3' ? '3022' : '3021';
            this.inputTypeCarteId.value = valueTranslator
            document.getElementById(this.portletName + 'typeCarteId').setAttribute('value', valueTranslator);
            this.cardTypeChange(valueTranslator);
        }
    }

    /** Recupera la tarjeta de un usuario, se ejecutara despues de que todos los demas datos esten cargados y solo si el usuario esta logueado */
    public getStudentRequest() {
        if (this.communesCargados && this.lineasCargadas && this.zonesCargadas && this.cardTypesCargadas && this.etablissementsCargadas && this.schoollevelsCargadas && this.provincesCargadas) {
            if (liferayUserNoAdmin) { // Si el usuario estaba logueado no se muestra el formulario hasta rellenarlo con sus datos
                this.recogerStudentCardsREST().subscribe(
                    (res) => { this.validateJSON(res, SearchSolicitudes), this.cardRequest = res.json().solicitudes, this.user = res.json().user, this.setValues() },
                    (err) => this.errorEnElJson(err, SearchSolicitudes)
                );
            } else { // Si el usuario no esta logueado se muestra nada mas que estan todos los datos cargados
                this.showForm = true;
                this.isNewCardForm = true;
                this.onFullyLoaded.emit(false);
            }
        }
    }

    public recogerStudentCardsREST(): Observable<Response> {
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        const options = new RequestOptions({ headers: headers });

        var urlLLamada = SearchSolicitudes + "&" + this.portletName + "actualCityRol=" + idCiudadLiferay + "&" + this.portletName + "searchingCriteria=" + "email==" + userLoggedEmail;
        // console.log(urlLLamada);
        return this.http.post(urlLLamada, "", options);
    }

    /**
     * Cumplimenta el formulario con los datos pasados desde el portlet cuando se accede al fomulario para una modificación
     */
    public setValues() {
        this.showForm = true;
        // console.log(this.cardRequest);
        if (this.cardRequest.length !== 0) {
            this.cardRequest = this.cardRequest[0];
            this.solicitud.setId(this.cardRequest.id);
            this.solicitud.setType_carte_id(this.cardRequest.type_carte_id);
            this.solicitud.setAgence(this.cardRequest.agence);
            this.solicitud.setSchoollevel(this.cardRequest.schoollevel);
            this.solicitud.setEtablissement(this.cardRequest.etablissement);
            this.solicitud.setNom(this.cardRequest.nom);
            this.solicitud.setPrenom(this.cardRequest.prenom);
            this.solicitud.setDate_naissance(this.cardRequest.date_naissance);
            this.solicitud.setCin(this.cardRequest.cin);
            this.solicitud.setTel(this.cardRequest.tel);
            this.solicitud.setEmail(this.cardRequest.email);
            this.solicitud.setLigne1(this.cardRequest.ligne1);
            this.solicitud.setLigne2(this.cardRequest.ligne2);
            this.solicitud.setProvince(this.cardRequest.province);
            this.solicitud.setCommune(this.cardRequest.commune);
            this.solicitud.setZone(this.cardRequest.zone);
            this.solicitud.setAdresse(this.cardRequest.adresse);
            this.solicitud.setTraitement(this.cardRequest.traitement);
            this.solicitud.setCode(this.cardRequest.code);
            this.solicitud.setMassarCode(this.cardRequest.massar);
            this.email = this.cardRequest.email;
            if (this.cityId == this.ID_CITY_AGADIR) {
                this.solicitud.setType_carte_id(Number.parseInt(this.cardRequest.zone == '3' ? '3022' : '3021'));
            }
            // console.log(this.solicitud);
            // We simulate the card type change to force the lines load and enable the subsequent validations
            this.cardTypeChange(this.solicitud.getType_carte_id().toString());

            this.solicitud.fixAllLines();
            //no es nueva tarjeta, es una edicion
            this.isNewCardForm = false;

            this.onFullyLoaded.emit(true);
        } else {
            // console.log(this.solicitud);
            if (this.user != undefined) {
                // Precargamos los datos del usuaro
                var cardRequestLiferay = JSON.parse(jsonCardRequestLiferay);

                this.solicitud.setCin(cardRequestLiferay.cin);
                this.solicitud.setNom(cardRequestLiferay.name);
                this.solicitud.setPrenom(cardRequestLiferay.surname);
                this.solicitud.setDate_naissance(cardRequestLiferay.birthdate);
                this.solicitud.setTel(cardRequestLiferay.phone);
                this.solicitud.setAdresse(cardRequestLiferay.address);
            }
            this.onFullyLoaded.emit(false);
        }
    }

    public getLines() {
        this.recogerLineasREST().subscribe(
            (res) => { this.validateJSON(res, GetLinesFromCity), this.jsonLineas = res.json(), this.cargarLineas(res.json()) },
            (err) => this.errorEnElJson(err, GetLinesFromCity)
        );
    }

    private recogerLineasREST(): Observable<Response> {
        var body = "";
        var urlLLamada = GetLinesFromCity + "&cityId=" + this.cityId + "&direction=0";
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }); // ... Set content type to JSON
        const options = new RequestOptions({ headers: headers }); // Create a request option
        return this.http.post(urlLLamada, body, options);
    }

    public cargarLineas(respuestaJSON: any) {
        this.jsonLineas = respuestaJSON;
        this.lineas[0] = new ClaveValorComponent(this.SELECT_NONE_VALUE, "");
        for (var i = 0; i < this.jsonLineas.lines.length; i++) {
            this.lineas[i + 1] = new ClaveValorComponent(this.jsonLineas.lines[i].id, this.jsonLineas.lines[i].name);
        }
        this.lineasCargadas = true;
        this.getStudentRequest();
    }

    public getProvinces() {
        this.recogerProvincesREST().subscribe(
            (res) => { this.validateJSON(res, GetCityProvinces), this.jsonProvinces = res.json(), this.cargarProvinces(res.json()) },
            (err) => this.errorEnElJson(err, GetCityProvinces)
        );
    }

    public cargarProvinces(respuestaJSON: any) {
        this.jsonProvinces = respuestaJSON;
        this.provinces = [];
        for (var i = 0; i < this.jsonProvinces.length; i++) {
            this.provinces.push(new ClaveValorComponent(this.jsonProvinces[i].id, this.jsonProvinces[i].nom));

        }
        if (this.jsonProvinces.length == 0) {
            this.provinces[0] = new ClaveValorComponent(this.SELECT_NONE_VALUE, "null");
        }
        this.provincesCargadas = true;
        // this.solicitud.setProvince(this.provinces[0].getId());
        this.getStudentRequest();
        /* if(this.jsonProvinces.length>0){
             document.getElementById(this.portletName + 'commune').removeAttribute('disabled');
             this.provinceChange(this.jsonProvinces[0].id);
         }*/

    }

    private recogerProvincesREST(): Observable<Response> {
        var urlLLamada = GetCityProvinces;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(urlLLamada, "", options);
    }

    public getCommunes() {
        this.recogerCommunesREST().subscribe(
            (res) => { this.validateJSON(res, GetCityCommunes), this.jsonCommunes = res.json(), this.cargarCommunes(res.json(), false) },
            (err) => this.errorEnElJson(err, GetCityCommunes)
        );
    }

    public cargarCommunes(respuestaJSON: any, isChange) {
        this.jsonCommunes = respuestaJSON;
        this.communes = [];
        for (var i = 0; i < this.jsonCommunes.length; i++) {
            if (this.jsonCommunes[i].active == true) {
                this.communes.push(new ClaveValorComponent(this.jsonCommunes[i].id, this.jsonCommunes[i].description));
            }
        }
        if (this.jsonCommunes.length == 0) {
            this.communes[0] = new ClaveValorComponent(this.SELECT_NONE_VALUE, "null");
        }
        this.communesCargados = true;
        if (!isChange) {
            this.getStudentRequest();
        }
        this.communeChange(this.jsonCommunes[0].id);
    }

    private recogerCommunesREST(): Observable<Response> {
        var urlLLamada = GetCityCommunes;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(urlLLamada, "", options);
    }

    public getZones() {
        this.recogerZonesREST().subscribe(
            (res) => { this.validateJSON(res, GetCityZonas), this.jsonZones = res.json(), this.cargarZones(res.json()) },
            (err) => this.errorEnElJson(err, GetCityZonas)
        );
    }

    public cargarZones(respuestaJSON: { zonas: any; }) {
        this.jsonZones = respuestaJSON.zonas;
        this.zones = [];
        for (var i = 0; i < this.jsonZones.length; i++) {
            if (this.jsonZones[i].active == true) {
                this.zones.push(new ClaveValorComponent(this.jsonZones[i].id, this.jsonZones[i].description));
            }
        }
        this.zonesCargadas = true;
        //this.solicitud.setZone(this.zones[0].getId());
        this.getStudentRequest();
    }

    private recogerZonesREST(): Observable<Response> {
        var urlFinal = GetCityZonas;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(urlFinal, "", options);
    }

    // Le pasamos directamente el texto dentro del value de un campo de fecha
    public validateMinimumAge(actualValueDate: string) {
        var birthday: any = new Date(actualValueDate);
        var ageDifMs = Date.now() - birthday;
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        var years = Math.abs(ageDate.getUTCFullYear() - 1970)
        if (years < parseInt(maximumAgeForCardRequest)) {
            return true;
        } else {
            this.onGeneralError.emit(this.i18nL.zz04_maxAge_allowed);
            return false;
        }
    }

    public omit_special_char(event: KeyboardEvent, spaces: boolean) {
        if (event.key.length > 1 || event.key.length <= 0) return false;
        let k = event.key.charCodeAt(0);
        if(spaces) return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
        else return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57));
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        if (!showServiceTermsLiferay) {
            this.initialize();
            this.initSelects();
            this.lineas[0] = new ClaveValorComponent(this.SELECT_LOADING_VALUE, this.i18nL.general_cargando);
            this.cardTypes[0] = new StudentCardTypeComponent(this.SELECT_LOADING_VALUE, this.i18nL.general_cargando, 0, false, 0, 0);
        }
        this.maxDate.setFullYear(this.maxDate.getFullYear() - 1);
        this.minDate.setFullYear(this.minDate.getFullYear() - 100);
    }

    // Recogemos los inputs
    ngAfterViewChecked() {
        this.inputName = <HTMLInputElement>document.getElementById(this.portletName + 'name');
        this.inputSurname = <HTMLInputElement>document.getElementById(this.portletName + 'surname');
        this.inputCin = <HTMLInputElement>document.getElementById(this.portletName + 'cin');
        this.inputBirthdate = <HTMLInputElement>document.getElementById(this.portletName + 'birthdate');
        this.inputAddress = <HTMLInputElement>document.getElementById(this.portletName + 'address');
        this.inputPhone = <HTMLInputElement>document.getElementById(this.portletName + 'phone');
        this.inputEmail = <HTMLInputElement>document.getElementById(this.portletName + 'email');
        this.inputDossierNumber = <HTMLInputElement>document.getElementById(this.portletName + 'dossierNumber');
        this.inputEtablissement = <HTMLInputElement>document.getElementById(this.portletName + 'etablissement');
        this.inputSchoollevel = <HTMLSelectElement>document.getElementById(this.portletName + 'schoollevel');
        this.inputProvince = <HTMLSelectElement>document.getElementById(this.portletName + 'province');
        this.inputCommune = <HTMLSelectElement>document.getElementById(this.portletName + 'commune');
        this.inputZone = <HTMLSelectElement>document.getElementById(this.portletName + 'zone');
        this.inputTypeCarteId = <HTMLSelectElement>document.getElementById(this.portletName + 'typeCarteId');
        this.inputMassarField = <HTMLInputElement>document.getElementById(this.portletName + 'massar');
        if (this.cityId == this.ID_CITY_AGADIR && this.inputEtablissement != null) {
            if (this.provinceSelected == null) {
                document.getElementById(this.portletName + 'commune').setAttribute('disabled', '');
            }
            if (this.schoollevelSelected == null) {
                document.getElementById(this.portletName + 'etablissement').setAttribute('disabled', '');
            }
            document.getElementById(this.portletName + 'zone').setAttribute('disabled', '');
        }
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private http: Http) { }
}



// WEBPACK FOOTER //
// ./src/app/requestForm/requestForm.component.ts